__turbopack_context__.v({
  "basicValuePropsList": "aLiUDW_basicValuePropsList",
});
